<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row">
            <div class="col-sm-6">
                <div class="title-wrapper">
                    <h1 class="title-default">Lista de Usuários</h1>
                    <p class="welcome-message">Gerenciamento de Usuários</p>
                </div>
            </div>
            <div class="col-sm-6">
                <a type="button" mat-flat-button class="btn-primary btn-add-right"
                    routerLink="/configuracoes/usuario/cadastrar">
                    <mat-icon>add</mat-icon>
                    Novo usuário
                </a>
            </div>
        </div>
        <form class="form" [formGroup]="model" (ngSubmit)="clickPesquisar()" class="search-area">
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Nome usuário</mat-label>
                        <input matInput formControlName="nomeUsuario" type="text">
                        <button mat-icon-button matSuffix type="button" (click)="clickPesquisar()"
                            aria-label="Pesquisar">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if(this._listaUsuarioResponse && this._listaUsuarioResponse.listaUsuario.length > 0){
        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

            <!-- Position Column -->
            <ng-container matColumnDef="idUsuario">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
                <td mat-cell *matCellDef="let element"> {{element.idUsuario}} </td>
            </ng-container>

            <ng-container matColumnDef="nomeUsuario">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome usuário </th>
                <td mat-cell *matCellDef="let element"> {{element.nomeUsuario}} </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>

            <ng-container matColumnDef="telefone">
                <th mat-header-cell *matHeaderCellDef> Telefone </th>
                <td mat-cell *matCellDef="let element"> {{element.telefone | foneMask}} </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/usuario/cadastrar', {idUsuario: element.idUsuario}]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <button mat-menu-item (click)="abrirModalExcluir(element.idUsuario, element.nomeUsuario)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="mobile-view">
            @for (item of _dataSource.data; track item.idUsuario) {
            <div class="card-mobile mb-3">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <span class="text-bold">{{item.nomeUsuario}}</span>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menuMobile" aria-label="Ações">
                        <span class="material-symbols-outlined">more_horiz</span>
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/usuario/cadastrar', {idUsuario: item.idUsuario}]">
                            <span class="material-symbols-outlined">edit</span>
                            <span>Editar</span>
                        </button>
                        <button mat-menu-item (click)="abrirModalExcluir(item.idUsuario, item.nomeUsuario)">
                            <span class="material-symbols-outlined">delete</span>
                            <span>Excluir</span>
                        </button>
                    </mat-menu>
                </div>
                <div class="card-body-mobile p-3">
                    <p class="mb-1"><strong>Email:</strong> {{item.email}}</p>
                    @if (item.telefone) {
                    <p class="mb-1"><strong>Telefone:</strong> {{item.telefone | foneMask}}</p>
                    }
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center ver-mais-pesquisa">
            <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                <span class="material-symbols-outlined">keyboard_arrow_down</span>
                Ver mais
                }
            </button>
        </div>
        }@else if(_isLoading === true){
        <app-loading-box-default-list></app-loading-box-default-list>
        }
        @else if(this._listaUsuarioResponse?.listaUsuario?.length === 0){
        <app-empty-list [title]="'Não foi encontrado nenhum usuário com o filtro informado'"></app-empty-list>
        }


    </div>
</div>